import axios from "axios"
import { SectionsResponse } from "types/sections"
import { withServerCache } from "utils/serverCache"

export default async function fetchSections(): Promise<SectionsResponse> {
    return withServerCache(
        "sections-list",
        async () => {
            const apiUrl = process.env.NEXT_PUBLIC_API_URL_V2
            const { data } = await axios.get(`${apiUrl}discovery/sectionslist`)
            return data
        },
        5 * 60 * 1000 // 5 minutes TTL
    )
}

// Alias for consistency
export { fetchSections as getSections }

